$(document).ready(function() {

    const PostAddToWishlist = (productId, doneCallback) => {
        $.ajax({
            method: 'POST',
            url: `/api/wishlist/add/${productId}`,
            headers: {
                'X-CSRFToken': csrf_token,
                'Content-Type': 'application/json'
            },
        }).done(doneCallback).fail(function(err) {
            console.error("Error:", err);
        });
    }

    const RemoveFromWishlist = (productId, doneCallback) => {
        $.ajax({
            method: 'DELETE',
            url: `/api/wishlist/remove/${productId}`,
            headers: {
                'X-CSRFToken': csrf_token,
                'Accept': '*/*'
            }
        }).done(doneCallback).fail(function(err) {
            console.error("Error:", err);
        });
    }
    
    $('.js-add-to-wishlist').on('click', function (e) {
        e.preventDefault();
        
        // 1. Get the parent product card
        const $card = $(this).closest('.product_card');
        
        // 2. Get the product ID from the data attribute
        const productId = $card.data('product-id');
        
        // 3. Check if the card is already in the wishlist
        if ($card.hasClass('in_wishlist')) {
            // Case: Already in wishlist -> Remove it
            RemoveFromWishlist(productId, function() {
                $card.removeClass('in_wishlist');
                showToast(`<h4 class="red">Wishlist</h4><p>Product removed from your wishlist.</p>`);
            });
        } else {
            // Case: Not in wishlist -> Add it
            PostAddToWishlist(productId, function() {
                $card.addClass('in_wishlist');
                showToast(`<h4 class="red">Wishlist</h4><p>Product added to your wishlist.</p>`);
            });
        }
    });

    $('.js-remove-from-wishlist').on('click', function (e) {
        e.preventDefault();
        
        // 1. Get the parent product card
        const $card = $(this).closest('.product');
        
        // 2. Get the product ID from the data attribute
        const productId = $card.data('product-id');
        
        // Case: Already in wishlist -> Remove it
        RemoveFromWishlist(productId, function() {
            $card.remove();
            showToast(`<h4 class="red">Wishlist</h4><p>Product removed from your wishlist.</p>`);
        });
    });    
})